import { Navigate, createBrowserRouter } from "react-router-dom"
import { lazy } from 'react';
import RootLayout from '../config/RootLayout';

const Home = lazy(() => (import("../pages/Home")));
const EmbassadorPage = lazy(() => (import("../pages/EmbassadorPage")));
const BlogsPage = lazy(() => (import("../pages/BlogsPage")));

const RouterConfig = createBrowserRouter([
    {
        path: '/',
        element: <RootLayout />,
        errorElement: <Navigate to={"/"} />,
        children: [
            { index: true, element: <Home /> },
            { path: '/pour-ambassadeur', element: <EmbassadorPage /> },
            { path: '/blogs', element: <BlogsPage /> },
        ],
    },
]);

export default RouterConfig;